<template>
  <div :class="$style.root" />
</template>

<style lang="scss" module>
@use '@/ui-kit/styles/colors';
@use '@/ui-kit/styles/shared';

@keyframes wave {
  0% {
    transform: translate(-100%);
  }

  to {
    transform: translate(100%);
  }
}
.root {
  position: relative;
  overflow: hidden;
  background: colors.$surface-4;
  border-radius: shared.$border-radius-s;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;

    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.45),
      rgba(255, 255, 255, 0)
    );
    animation: wave 1.5s linear 0.5s infinite;
  }
}
</style>
